import APIClient from './index';

const getSignedUrl = async params => {
  return APIClient.post('Uploads', params)
    .then(response => response.data)
    .catch(err => console.log(err));
};

export { getSignedUrl };
